import { render, staticRenderFns } from "./PredictedFlow.vue?vue&type=template&id=35100bd9"
import script from "./PredictedFlow.vue?vue&type=script&lang=ts"
export * from "./PredictedFlow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports